module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "zk-dropdown-menu__item",
    class: {
      'is-disabled': _vm.disabled,
      'zk-dropdown-menu__item--divided': _vm.divided
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-69a27571"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/dropdown/src/dropdown-item.vue
// module id = 264
// module chunks = 0